export const DOWNLOAD_URL = 'https://www.owenscorning.com/dms/10027540';

export const FOOTER_TEXT =
  'We strive to accurately reproduce all photographs of shingles in literature and for onscreen viewing. The roofing product colors you see are as accurate as technology allows. We suggest that you view a roofing display or several shingles to get a better idea of the actual color. To accurately judge your shingle and color choice, we recommend that you actual roof with a pitch similar to your own roof prior to making your your final color selection.';

export const TITLE = 'GO ROOF GAWKING<small>&trade;</small> FOR COLOR INSPIRATION!';

export const OC_LOGO_URL = 'https://imagecdn.owenscorning.com/image/upload/v1575575892/meganav/oc-logo.svg';

export const WIDGET_IMAGE_URL =
  'https://imagecdn.owenscorning.com/image/upload/v1721055144/roofing/roof-smart/woman-driving.png';

export const WIDGET_DESCRIPTION = `
  <p>
    The first step in picking your perfect shingle color? Scout your neighborhood for great-looking roofs, what Owens
    Corning likes to call Roof Gawking™. When you catch yourself spontaneously gazing at a roof, you know you found one!
  </p>
  <p>
    Once you've found a few you like, it's time discover what would look best on your home. We can help. Just download the
    Shingle Color Selection Checklist for step-by-step guidance.
  </p>
  <p>
    Because when you invest in a new roof, you shouldn't just like the results. <b>You should love them.</b>
  </p>
`;
